// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.project-settlement-software[data-v-6d8fe828] {
  padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/ProjectSettlementSoftware/index.vue"],"names":[],"mappings":";AA8BA;EACA,aAAA;AACA","sourcesContent":["<template>\n  <div class=\"project-settlement-software\">\n    <h2>工程结算软件</h2>\n    <p>这里是工程结算软件页面的内容</p>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'ProjectSettlementSoftware',\n    data() {\n      return {\n        // 页面数据\n      }\n    },\n    mounted() {\n      // 页面初始化逻辑\n    },\n    methods: {\n      // 页面方法\n    }\n  }\n</script>\n\n<style scoped>\n  .project-settlement-software {\n    padding: 20px;\n  }\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
